const ru = {
  title: 'Платёжная страница',
  subtitle: '',
  status: {
    successTitle: 'Платёж завершён',
    successDescriptionPrefix: '',
    failedTitle: 'Платёж отклонён',
    failedDescriptionPrefix: '',
    awaitingTitle: 'Ожидаем данные',
    awaitingDescription: 'Необходимо передать дополнительные поля, чтобы продолжить обработку.',
    formTitleFallback: 'Введите данные',
    redirectTitle: 'Перенаправляем…',
    redirectDescription: 'Если окно не открылось автоматически, воспользуйтесь кнопкой ниже.',
    redirectButton: 'Перейти',
    infoTitleFallback: 'Информация для оплаты',
    infoButton: 'Продолжить',
    pendingTitle: 'Операция выполняется',
    pendingDescription: 'Ожидаем ответ провайдера. Вы можете обновить статус вручную.',
    refreshButton: 'Обновить статус',
    refreshBusy: 'Обновляем…',
    checkAgain: 'Проверить ещё раз',
    tryAgain: 'Попробовать снова',
    infoBusy: 'Продолжаем…',
    redirectLinkAction: 'Вернуться на страницу сервиса'
  },
  infoDetails: {
    account_name: 'Имя владельца счёта',
    account_number: 'Номер счёта',
    bank_code: 'Код банка',
    bank_name: 'Банк',
    expiry_date_in_utc: 'Дата истечения (UTC)',
    provider_name: 'Провайдер',
    merchant_name: 'Мерчант',
    payment_method: 'Платёжный метод',
    transaction_type: 'Тип транзакции'
  },
  order: {
    heading: 'Данные заказа',
    primaryLabel: 'Идентификатор заказа',
    secondaryLabel: 'Идентификатор заказа 2',
    providerLabel: 'Провайдер',
    merchantLabel: 'Мерчант',
    paymentMethodLabel: 'Платёжный метод',
    transactionTypeLabel: 'Тип транзакции',
    transactionLabel: 'Идентификатор транзакции',
    transactionRefLabel: 'Ссылка на транзакцию',
    amountLabel: 'Сумма',
    currencyLabel: 'Валюта',
    statusToggleShow: 'Показать статус',
    statusToggleHide: 'Скрыть статус',
    transactionTypes: {
      '4': 'Возврат / чарджбэк',
      '15': 'СБП возврат',
      '16': 'Выплата',
      '17': 'Пополнение'
    },
    paymentMethods: {
      '0': 'T-Money',
      '1': 'M-PESA',
      '2': 'Airtel',
      '3': 'Orange Money',
      '4': 'Afrimoney',
      '5': 'MTN',
      '6': 'Zamtel',
      '7': 'Lumicash',
      '8': 'Банковский перевод',
      '9': 'Банковская карта',
      '10': 'Симулятор',
      '11': 'Avada Cash',
      '12': 'Tigo',
      '13': 'Vodafone',
      '15': 'Equitel',
      '16': 'Snapscan',
      '17': 'Ozow',
      '18': 'HaloPesa',
      '19': 'Mobile Money Cameroon',
      '20': 'Mobile Money Burkina Faso',
      '21': 'Mobile Money Ivory Coast',
      '22': 'Mobile Money Zambia',
      '23': 'E-Money',
      '24': 'Free Money',
      '25': 'T-Kash',
      '26': 'Expresso',
      '27': 'Buddy',
      '28': 'Mobile Money Rwanda',
      '29': 'Dalapay Cash',
      '30': 'Wave',
      '31': 'Vodacom',
      '33': 'TOGOCOM',
      '34': 'MOOV Money',
      '35': 'Mobicash',
      '36': 'Pay Attitude',
      '37': 'OPay',
      '38': 'Palmpay',
      '39': 'AzamPesa',
      '40': 'Celtiis',
      '41': 'Agents Network',
      '42': 'Cellulant',
      '43': 'Etisalat',
      '44': 'Instapay',
      '45': 'CIB Smart Wallet',
      '46': 'Voucher',
      '47': 'TNM',
      '48': 'EU Mobile',
      '49': 'Youmee',
      '50': 'Yas',
      '51': 'Baridi',
      '52': 'Nagad',
      '53': 'bKash',
      '54': 'EasyPaisa',
      '55': 'JazzCash',
      '56': 'BM Wallet',
      '57': 'Fawry',
      '58': 'Wepay',
      '59': 'EazyPesa',
      '60': 'T-Pesa',
      '61': 'Telcom',
      '62': 'Zeepay',
      '63': 'Biat',
      '64': 'Flouci',
      '65': 'D17',
      '66': 'Tikmoney Cash'
    }
  },
  statusBanner: {
    resultTitle: 'Код результата',
    providerTitle: 'Ответ провайдера'
  },
  form: {
    submit: 'Продолжить',
    selectPlaceholder: 'Выберите…',
    validationFallback: 'Заполните поле',
    pending: 'Заполните поле',
    invalidFormat: 'Введите корректное значение',
    processing: 'Обработка…',
    /** Ключ = текст legend с бэкенда, значение = перевод */
    formLegendTranslations: {
      'Please enter customer full name (will be used for account name and customer details)': 'Введите полное имя клиента (будет использоваться для имени аккаунта и данных клиента)',
      'Please enter customer email address': 'Введите email адрес клиента',
      'Customer full name': 'Полное имя клиента',
      'Customer email address': 'Email адрес клиента'
    },
    /** Ключ = текст description с бэкенда, значение = перевод */
    formDescriptionTranslations: {
      'Customer full name': 'Полное имя клиента',
      'Customer email address': 'Email адрес клиента'
    }
  },
  error: {
    title: 'Ошибка',
    summary: 'Не удалось обработать запрос.',
    showDetails: 'Показать детали',
    hideDetails: 'Скрыть детали',
    retry: 'Повторить',
    retrying: 'Повторяем…'
  }
} as const;

export default ru;
